import React from "react";
import i18n from "@i18n";
import styles from "./Controls.module.less";
import { NavButtonConfig } from "./QuestionDefinition";
import { Text } from "../core/Text";
import Button from "src/design-system/components/Button/Button";
import { ctaStyles } from "src/design-system/styles/layout";

interface ControlsProperties {
  next?: NavButtonConfig;

  isLoading?: boolean;
  canProceed?: boolean;

  /** Callback handler executed when the user clicks the next button. */
  onClickNext?: () => void;

  hideControls?: boolean;
  useStickyControls?: boolean;
  useStickyControlsAllViewports?: boolean;
  "data-cy"?: string;
}
const Controls = ({
  next = { text: i18n.t("survey-controls-2:next") },

  isLoading,
  canProceed,

  onClickNext,
  hideControls = false,
  useStickyControls = false,
  useStickyControlsAllViewports = false,
  "data-cy": dataCy = "survey-next",
}: ControlsProperties) => {
  if (hideControls || (next && next.disabled)) {
    return null;
  }

  const shouldUseStickyControls = () => {
    if (canProceed) {
      if (useStickyControls) {
        return styles.sticky;
      }
      if (useStickyControlsAllViewports) {
        return styles.stickyAllViewports;
      }
    }
    return "";
  };

  const getControlsPlaceholder = () => {
    if (useStickyControlsAllViewports) {
      return styles.controlsPlaceholderStickyAllViewports;
    }
    return styles.controlsPlaceholder;
  };

  return (
    <>
      <div className={`${styles.controls} ${shouldUseStickyControls()}`}>
        <Button
          type={onClickNext ? "button" : "submit"}
          onClick={onClickNext && (() => onClickNext())}
          disabled={!canProceed || isLoading}
          data-cy={dataCy}
          css={ctaStyles}
        >
          <Text i18nKeyOrText={next.text} />
        </Button>
      </div>
      {/* pad bottom of page when button is sticky. */}
      {shouldUseStickyControls() && (
        <div className={getControlsPlaceholder()} />
      )}
    </>
  );
};

export default Controls;
